import {
  SwipeableProductList,
  SwipeableProductListProps,
} from "@made-people/blueprint-swipeable-product-list";
// import { ChevronLeft } from "../../../../assets/icons/ChevronLeft";
// import { ChevronRight } from "../../../../assets/icons/ChevronRight";
import { withManagedProps } from "@made-people/managed-props";

export const MiniCartSwipeableProductListDefaults = {
  settings: {
    template: "template1",
    // navigation: {
    //   prevIcon: <ChevronLeft />,
    //   nextIcon: <ChevronRight />,
    // },
    variants: {
      background: "none",
      layout: "stacked",
    },
    spacing: {
      x: "none",
      y: "md",
      gap: {
        initial: "xs",
        md: "sm",
        lg: "md",
      },
      maxWidth: "page",
    },
    headerSettings: {
      heading: {
        headingTag: "h3",
        variants: {
          eyebrowSize: { initial: "sm", lg: "md" },
          headingSize: { initial: "sm", lg: "sm" },
        },
      },
    },
  },
  productCardSettings: {
    templateProps: {
      template: "1",
      productInfoText: {
        attributeKey: "",
      },
      swatches: {
        className: "hidden",
      },
      badges: {
        className: "hidden",
      },
      price: {
        variants: {
          spacing: "false",
          size: "sm",
        },
      },
      details: {
        variants: {
          spacing: "false",
          size: "sm",
        },
      },
      gallery: {
        variants: {
          rounded: "true",
        },
      },
      quickshop: {
        gallery: {
          configs: [
            {
              config: {
                sizesCount: {
                  from: 2,
                  to: 25,
                },
                optionsCount: {
                  from: 0,
                  to: 1,
                },
              },
              template: {
                template: "button-grid",
                variants: {
                  placeIn: "gallery",
                },
              },
            },
            {
              config: {
                sizesCount: {
                  from: 1,
                  to: 20,
                },
                optionsCount: {
                  from: 1,
                  to: 10,
                },
              },
              template: {
                template: "drawer",
                postAddAction: "closeDrawer",
                drawerSettings: {
                  nested: false,
                },
                variants: {
                  placeIn: "gallery",
                },
              },
            },
          ],
        },
        details: {
          configs: [],
        },
      },
    },
  },
} satisfies SwipeableProductListProps;

export const MiniCartSwipeableProductList = withManagedProps(
  "MiniCartSwipeableProductList",
  (props: SwipeableProductListProps) => {
    return <SwipeableProductList {...props} />;
  },
);
